import { GenericService } from 'services/genericService';
import { Observable } from 'rxjs';
import { riyadaCustomerIdentifier } from 'utils/api/queries/omantelMicroApi';
import { AjaxResponse } from 'rxjs/ajax';

export class RiyadaCustomerIdentifier extends GenericService {
	//API to check if customer is Riyada customer or not, crNumber is the documentId for the selected organization.
	public static isRiyadaCustomer(crNumber: number, isBomOn: boolean = false): Observable<AjaxResponse> {
		return riyadaCustomerIdentifier(crNumber, isBomOn)
			.withErrorHandling()
			.disableCache()
			.call();
	}
}
